import Objects from "./Objects.js";
class Role {
	static loadAllbyUser(user, callback){
		Objects.post(user, callback, Role.ENDPOINT + "all");
	}
}
Role.ENDPOINT = "/api/Role/"
export default Role;